import {isMembersAreaInstalled} from '@wix/members-area-integration-kit';
import {doTransaction} from '../transaction';
import {PageMap} from '@wix/wixstores-client-core/dist/es/src/constants';
import {DependantApps} from '../services/DependantApps';
import {StyleParams} from '../services/StyleParams';
import {EditorSDK, StyleParam} from '@wix/platform-editor-sdk';
import {createWishlistApi, InstallationOrigin} from './wishlist/wishlistActions';
import {AppApiModel} from '@wix/wixstores-client-core/dist/src/types/app-api-model';
import {clickToPreviewWishlistInMembersSfe} from '@wix/bi-logger-ec-sf/v2';
import {Logger as WebBiLogger} from '@wix/web-bi-logger/dist/src/types';
import {WIX_ECOM, WIX_NEW_STORES} from '@wix/app-definition-ids';

export function createAppApi({
  sdk,
  dependantApps,
  styleParams,
  t,
  webBiLogger,
}: {
  sdk: EditorSDK;
  dependantApps: DependantApps;
  styleParams: StyleParams;
  t: (keyToTranslate: string) => string;
  webBiLogger: WebBiLogger;
}): AppApiModel {
  const wishlistApi = createWishlistApi({sdk, dependantApps, t, webBiLogger});
  return {
    isMembersInstalled: () => isMembersAreaInstalled(sdk),
    installMembersAreaAndWishlistPage: (openerCompRef: string, styleParamKey?: string) =>
      wishlistApi.installWishlist({
        openerCompRef,
        origin: InstallationOrigin.Settings,
        installMembersArea: true,
        styleParamKey,
      }),
    installWishlist: (openerCompRef: string, styleParamKey?: string) =>
      wishlistApi.installWishlist({
        openerCompRef,
        origin: InstallationOrigin.Settings,
        installMembersArea: false,
        styleParamKey,
      }),
    uninstallWishlist: () => wishlistApi.uninstallWishlist(),
    isAppInstalled: (appDefinitionId: string) => {
      return dependantApps.isAppInstalled(appDefinitionId);
    },
    isMyWishlistInstalled: () => {
      return dependantApps.isMyWishlistInstalled(sdk);
    },
    setCheckoutStyleParam(type: StyleParam['type'], key: string, param: {value: any}): Promise<void> {
      return doTransaction(sdk, () => styleParams.setCheckoutStyleParam(type, key, param));
    },
    addShopPage: (title?: string) => {
      return doTransaction(sdk, async () => {
        const allSitePages = await sdk.pages.data.getAll('');
        const ecomPages = allSitePages.filter(({managingAppDefId}) => managingAppDefId === WIX_ECOM);
        const managingAppDefId = ecomPages.some((page) => page.tpaPageId === PageMap.PRODUCT)
          ? WIX_ECOM
          : WIX_NEW_STORES;
        return sdk.tpa.add.component('', {
          appDefinitionId: WIX_ECOM,
          managingAppDefId,
          page: {pageId: 'product_gallery', title},
          componentType: 'PAGE',
        });
      });
    },
  };
}

export async function navigateToWishlist(dependantApps: DependantApps, webBiLogger) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  webBiLogger.report(clickToPreviewWishlistInMembersSfe({}));
  return dependantApps.navigateToWishlist();
}
